import { useEffect, useState } from "react";

import { Card } from "../../custom";
import styles from "./main.module.scss";
import IconLabel from "./iconLabel";
import { ReactComponent as TargetIcon } from "../../assets/target.svg";
import { ReactComponent as BulbIcon } from "../../assets/bulb.svg";
import { ReactComponent as NextIcon } from "../../assets/next.svg";
import { ReactComponent as PreviousIcon } from "../../assets/previous.svg";
import { useQueries } from "@tanstack/react-query";
import {
  getAllAboutUs,
  getAllHistory,
  getAllManagement,
  SchoolMgt,
  History,
} from "../../requests/aboutUs";
import DOMPurify from "dompurify";
import { Spin } from "antd";
import { useLocation } from "react-router-dom";

const AboutUs = () => {
  const [currentIndex, setCurrentIndex] = useState(0);

  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      const element = document.getElementById(location.hash.substring(1));
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
      }
    }
  }, [location]);

  const queries = useQueries({
    queries: [
      {
        queryKey: ["get-about-us"],
        queryFn: getAllAboutUs,
      },
      {
        queryKey: ["get-history"],
        queryFn: getAllHistory,
      },
      {
        queryKey: ["get-management"],
        queryFn: getAllManagement,
      },
    ],
  });

  const getAllAboutUsQuery = queries[0];
  const getAllHistoryQuery = queries[1];
  const getAllManagementQuery = queries[2];

  const {
    data: getAllAboutUsData,
    isLoading: isLoadingAboutUs,
    isError: isAboutUsError,
    error: aboutUsError,
  } = getAllAboutUsQuery;

  const aboutUsData = getAllAboutUsData?.data;
  const historyData = getAllHistoryQuery?.data?.data;
  const managementData = getAllManagementQuery?.data?.data;

  const handlePrevClick = () => {
    managementData &&
      setCurrentIndex((prevIndex) =>
        prevIndex < 0 ? prevIndex - 1 : managementData.length - 3
      );
  };

  const handleNextClick = () => {
    managementData &&
      setCurrentIndex((prevIndex) =>
        prevIndex < managementData.length - 3 ? prevIndex + 1 : 0
      );
  };

  const displayItems =
    managementData && managementData.length < 3
      ? managementData
      : managementData?.slice(currentIndex, currentIndex + 3);

  return (
    <div>
      <section className={styles.banner}>
        <h1>About Us</h1>
      </section>

      <section className={styles.missionAndVision}>
        <div>
          {aboutUsData &&
            aboutUsData?.map(
              (item) =>
                item?.activeStatus === true && (
                  <div key={item?.id}>
                    <Card className={styles.cardStyle}>
                      <div className={styles.cardChildren}>
                        <h3>{item?.title}</h3>
                        <p
                          dangerouslySetInnerHTML={{
                            __html: DOMPurify.sanitize(item.description),
                          }}
                        ></p>
                      </div>
                    </Card>

                    <IconLabel>
                      <img
                        src={item?.imageUrl}
                        alt="about-us"
                        className="logos"
                      />
                      {/* <TargetIcon /> */}
                    </IconLabel>
                  </div>
                )
            )}
          {/* <div>
            <Card className={styles.cardStyle}>
              <div className={styles.cardChildren}>
                <h3>MISSION AND VALUES</h3>
                <p>
                  Kwararafa University is a distinguished public university,
                  values learning in the business, education and sciences as a
                  cornerstone of individual development and a vital foundation.
                  We will ensure that our students develop both the skills that
                  a sound education provides and the competencies essential for
                  success and leadership in the emerging creative economy. We
                  will also lead to generating practical and theoretical
                  knowledge that enables people to better understand our world
                  and improve conditions for local and global communities.
                </p>
              </div>
            </Card>

            <IconLabel>
              <TargetIcon className={styles.icon} />
            </IconLabel>
          </div>
          <div>
            <Card className={styles.cardStyle}>
              <div className={styles.cardChildren}>
                <h3>VISION</h3>
                <p>
                  At Kwararafa University, we will be the preeminent
                  intellectual and creative center for effective engagement in a
                  world that increasingly demands better-designed objects,
                  communication, systems, and organizations to meet social
                  needs.
                </p>
              </div>
            </Card>

            <IconLabel>
              <BulbIcon className={styles.icon} />
            </IconLabel>
          </div> 
           <IconLabel>
              {/* <TargetIcon /> 
            </IconLabel>
          */}
        </div>
      </section>

      <hr />

      {historyData &&
        historyData?.map(
          (item) =>
            item?.activeStatus === true && (
              <section className={styles.history} key={item?.id}>
                <div>
                  <img
                    src={item?.imageUrl}
                    alt="history"
                    className={styles.historyImg}
                  />
                </div>

                <div>
                  <div>
                    <h3>HISTORY</h3>
                    <div className={styles.lineWrapper}>
                      <span className={styles.linkLine}></span>
                    </div>
                  </div>

                  <p
                    dangerouslySetInnerHTML={{
                      __html: DOMPurify.sanitize(item.description),
                    }}
                  ></p>
                </div>
              </section>
            )
        )}

      <hr />

      <section className={styles.management}>
        <div>
          <h3>SCHOOL MANAGEMENT</h3>
          <div className={styles.lineWrapper}>
            <span className={styles.linkLine}></span>
          </div>
        </div>

        <div className={styles.cardContainer}>
          {managementData && managementData.length > 3 && (
            <div className={styles.prevButton} onClick={handlePrevClick}>
              <PreviousIcon />
            </div>
          )}

          {displayItems &&
            displayItems.map((item, index) => (
              <Card key={index} className={styles.managementCard}>
                <div>
                  <img
                    src={item.imageUrl}
                    alt="management"
                    className={styles.managementImg}
                  />

                  <div>
                    <h4>{item.title}</h4>
                    <p>{item.description}</p>
                  </div>
                </div>
              </Card>
            ))}

          {managementData && managementData?.length > 3 && (
            <div className={styles.nextButton} onClick={handleNextClick}>
              <NextIcon />
            </div>
          )}
        </div>
      </section>
    </div>
  );
};

export default AboutUs;

// const managementData = [
//   {
//     img: "/prof_1.png",
//     name: "Prof Austin Agu",
//     description: "Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis natoque penatibus.",
//   },
//   {
//     img: "/prof_2.png",
//     name: "Prof Austin Agu",
//     description: "Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis natoque penatibus.",
//   },
//   {
//     img: "/prof_3.png",
//     name: "Prof Austin Agu",
//     description: "Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis natoque penatibus.",
//   },
//   {
//     img: "/prof_3.png",
//     name: "Prof Austin Agu",
//     description: "Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis natoque penatibus.",
//   },
//   {
//     img: "/prof_1.png",
//     name: "Prof Austin Agu",
//     description: "Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis natoque penatibus.",
//   },
//   {
//     img: "/prof_2.png",
//     name: "Prof Austin Agu",
//     description: "Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis natoque penatibus.",
//   },
// ];
